import * as PIXI from 'pixi.js';
import {Assets} from 'pixi.js';
import {GameObject, IDestroy} from "../../base/GameObject";
import {LibraryMold} from "./LibraryMold";
import {AbstractPixiRoot} from "../../AbstractPixiRoot";
import {MovieMold} from "./MovieMold";
import {Container} from "../display/Container";
import {Movie} from "../display/Movie";
import {Button} from "../display/Button";
import {TabButton} from "../display/TabButton";
import {ClickArea} from "../display/ClickArea";
import {TextInput} from "../display/TextInput";
import {Checkbox} from "../display/Checkbox";
import {GameView} from "../../base/GameView";

export interface DisplayObjectFrameState {
  x: number;
  y: number;
  scaleX: number;
  scaleY: number;
  skewX: number;
  skewY: number;
  pivotX: number;
  pivotY: number;
  alpha: number;
  visible: boolean;
}

export class LibraryFlump extends GameObject {

  static readonly FLUMP_LABEL = "label";
  static readonly FLUMP_CLASS = "CLASS:";
  static readonly FLUMP_PLACER = "PLACER:";
  static readonly FLUMP_CONTENT = "CONTENT";
  static readonly FLUMP_IGNORE = "IGNORE";
  static readonly FLUMP_STATE_UP = "STATE_UP";
  static readonly FLUMP_STATE_DOWN = "STATE_DOWN";
  static readonly FLUMP_BOX = "BOX";
  static readonly FLUMP_CHECK = "CHECK";
  static readonly FLUMP_TEXT = "TEXT:";

  private name!: string;
  private creatorsMap: Record<string, IDestroy> = {};
  private libraryMold!: LibraryMold;

  readonly pixiRoot: AbstractPixiRoot;

  constructor(pixiRoot: AbstractPixiRoot) {
    super();
    this.pixiRoot = pixiRoot;
  }

  unloadAssets() {
    // TODO!!!!!!!!
  }

  public init(name: string, libraryMold: LibraryMold) {
    this.name = name;

    this.libraryMold = libraryMold;
    const textureGroup = this.libraryMold.bestTextureGroupForScaleFactor(this.pixiRoot.app.device.devicePixelRatio);

    if (textureGroup) {
      for (const atlasMold of textureGroup.atlasMolds) {
        const scale = atlasMold.scaleFactor;

        for (const atlasTextureMold of atlasMold.atlasTextureMolds) {

          let bounds = atlasTextureMold.bounds;
          let origin = atlasTextureMold.origin;

          // Преобразуем границы и координаты для масштаба
          if (scale !== 1) {
            bounds = bounds.clone();
            bounds.x = bounds.x / scale;
            bounds.y = bounds.y / scale;
            bounds.width = bounds.width / scale;
            bounds.height = bounds.height / scale;

            origin = origin.clone();
            origin.x = origin.x / scale;
            origin.y = origin.y / scale;
          }

          const cache = Assets.cache;
          const symbol = atlasTextureMold.symbol;
          const texture = cache.get(symbol);
          if (!texture) {
            this.pixiRoot.app.log("SpriteCreator texture for symbol: " + symbol + " = null!!!");
          }
          this.addCreator(atlasTextureMold.symbol, new SpriteCreator(texture, origin, symbol));
        }
      }
    }

    for (const movieMold of this.libraryMold.movieMolds) {
      this.addCreator(movieMold.symbol!, movieMold);
    }
  }

  public getMovieMoldBySymbol(symbol: string) {
    for (let movieMold of this.libraryMold.movieMolds) {
      if (movieMold.symbol == symbol) {
        return movieMold;
      }
    }
    return null;
  }

  public getTexture(name: string): PIXI.Texture | undefined {
    const cache = Assets.cache;
    const value = cache.get(name);
    return value as PIXI.Texture;
  }

  public createImage(textureName: string) {
    return this.create(textureName) as PIXI.Sprite;
  }

  public createMovie(movieName: string) {
    return this.create(movieName) as Movie;
  }

  public createContainer(containerName: string) {
    return this.create(containerName) as Container;
  }

  create(symbolName: string) {
    const creator = this.creatorsMap[symbolName];
    if (!creator) {
      this.pixiRoot.app.logError(`ERROR: no creator found for symbol: ${symbolName}`);
    }

    let displayObject!: PIXI.Container;

    if (creator instanceof SpriteCreator) {
      displayObject = creator.createSprite();
    } else if (creator instanceof MovieMold) {
      const movieMold = creator as MovieMold;
      const flumpLabel = movieMold.flumpClassLabel;

      if (flumpLabel.includes(LibraryFlump.FLUMP_CLASS)) {
        const className = flumpLabel.replace(LibraryFlump.FLUMP_CLASS, '');
        let container = this.createContainerByClassName(className, movieMold);
        if (!creator) {
          this.pixiRoot.app.logError(`ERROR: CustomContainerCreator:create - Unknown class ${className}`);
        }
        displayObject = container!;
      } else {
        displayObject = new Movie(movieMold, this);
      }
    } else {
      this.pixiRoot.app.logError(`ERROR: wrong symbol creator: ${symbolName}`);
    }

    if (displayObject instanceof GameView) {
      (displayObject as GameView).root = this.pixiRoot;
    }
    if (displayObject instanceof Container) {
      (displayObject as Container).build();
    }
    return displayObject;
  }

  protected createContainerByClassName(className: string, movieMold: MovieMold):Container | null {
    switch (className) {
      case 'Container':
        return new Container(movieMold, this);
      case 'Button':
        return new Button(movieMold, this);
      case 'TabButton':
        return new TabButton(movieMold, this);
      case "ClickArea":
        return new ClickArea(movieMold, this);
      case "TextInput":
        return new TextInput(movieMold, this);
      case "Checkbox":
        return new Checkbox(movieMold, this);
      default:
        return null;
    }
  }

  applyFrameState(displayObject: PIXI.Container, state: DisplayObjectFrameState) {
    if (displayObject instanceof PIXI.Sprite) {
      displayObject?.anchor?.set(0);
    }

    if (state.skewX == state.skewY) {
      displayObject.skew.set(0, 0);
      displayObject.angle = 0;
      displayObject.rotation = state.skewX;
    } else if (state.skewX > 0 && state.skewY < 0) {
      // displayObject.rotation = 0;
      displayObject.skew.set(-state.skewX, -state.skewY);
      // displayObject.rotation = state.skewY;
    } else {
      displayObject.skew.set(state.skewX, state.skewY);
      displayObject.rotation = 0;
    }
    displayObject.pivot.set(state.pivotX, state.pivotY);
    displayObject.position.set(state.x, state.y);
    // if (displayObject.parent) {
    //   displayObject.scale.set(state.scaleX / displayObject.parent.scale.x, state.scaleY / displayObject.parent.scale.y);
    // } else {
    //   displayObject.scale.set(state.scaleX, state.scaleY);
    // }
    displayObject.scale.set(state.scaleX, state.scaleY);

    displayObject.alpha = state.alpha;
    displayObject.visible = state.visible;
  }

  override destroy(): void {
    this.unloadAssets();
    super.destroy();
    for (const key in this.creatorsMap) {
      this.creatorsMap[key].destroy();
      delete this.creatorsMap[key];
    }
    this.creatorsMap = {};
  }

  private addCreator(symbol: string, creator: IDestroy): void {
    if (this.creatorsMap[symbol]) {
      console.error(`LibraryFlump:addCreator '${symbol}' creator already exists!`);
    }
    this.creatorsMap[symbol] = creator;
  }
}

class SpriteCreator extends GameObject {

  private texture: PIXI.Texture;
  private origin: { x: number; y: number };
  private symbol: string;

  constructor(texture: PIXI.Texture, origin: { x: number; y: number }, symbol: string) {
    super();
    this.texture = texture;
    this.origin = origin;
    this.symbol = symbol;
  }

  createSprite(): PIXI.Sprite {
    const sprite = new PIXI.Sprite(this.texture);
    sprite.anchor.set(this.origin.x / this.texture.width, this.origin.y / this.texture.height);
    return sprite;
  }
}
